<template>
  <div class="container-box" v-loading="oLoading.pageLoading">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">企业租赁方案详情</template>
        <div class="splitline" />
      </QS-h3-title>
      <QS-h4-title title="方案基本信息" />
      <div>
        <column-box-expand
          :list="baseCloumn"
          :source="baseSource"
          separator="："
        />
      </div>
      <QS-h4-title title="租赁规则配置" />
      <div class="orderConfig">
        <column-box-expand
          :list="configColumn"
          :source="configSource"
          separator="："
        />
      </div>
      <!-- 支付计划列表 -->
      <el-table
        v-if="feeTableData.length"
        class="add-table"
        max-height="300"
        :data="feeTableData"
        style="width: 100%"
        row-key="fundType"
      >
        <el-table-column align="center" label="收款项" prop="name" />
        <el-table-column align="center" label="收款方式">
          <template slot-scope="scope">
            {{ getPayModeText(scope.row.payMode) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="收款金额">
          <template slot-scope="scope">
            {{ formatAmount(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="缴款日">
          <template slot-scope="scope">
            {{ formatPayDay(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
      <template slot="bottomAction">
        <el-button
          v-if="state === 0 && judgePermission('enterprise_plan_edit')"
          @click="goEditPage"
          type="primary"
          size="small"
          >编辑</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
import { getEnterprisePlanDetail } from '@/api/domain/leaseScheme'
import { ENTERPRISE_PLAN_STATUS } from './const'
import { categoryList } from '@/store/dict/rentPlanDict'

const RENT_PERIOD_TYPE_MAP = {
  1: '天',
  2: '周',
  3: '月',
}

const PAY_MODE_MAP = {
  1: '年付',
  2: '半年一付',
  3: '周付',
  4: '月付（满月）',
  5: '月付（自然月）',
  6: '一次性',
}

export default {
  name: 'EnterprisePlanDetail',
  data() {
    return {
      id: '',
      state: '',
      oLoading: {
        pageLoading: false,
      },
      baseSource: {
        id: '',
        stateName: '',
        gmtCreate: '',
        name: '',
        orderTypeName: '企业订单',
        brandName: '',
        seriesName: '',
        modelName: '',
      },
      baseCloumn: [
        { name: '方案ID', key: 'id' },
        { name: '方案状态', key: 'stateName' },
        { name: '创建时间', key: 'gmtCreate' },
        { name: '方案名称', key: 'name' },
        { name: '订单类型', key: 'orderTypeName' },
        { name: '品牌', key: 'brandName' },
        { name: '车系', key: 'seriesName' },
        { name: '车型', key: 'modelName' },
      ],
      configColumn: [
        { name: '租赁类型', key: 'rentCategoryName' },
        { name: '预计租赁周期', key: 'rentPeriodName' },
        { name: '赠送天数（天）', key: 'presentDays' },
      ],
      configSource: {
        rentCategoryName: '',
        rentPeriodName: '',
        presentDays: '',
      },
      feeTableData: [],
    }
  },
  mounted() {
    this.id = this.$route.query.id
    if (!this.id) {
      this.$message.error('缺少ID参数')
      return
    }
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.oLoading.pageLoading = true
      const { code, data } = await getEnterprisePlanDetail({
        id: Number(this.id),
      })
      if (code === 1) {
        this.state = data.state
        this.setData(data)
      }
      this.oLoading.pageLoading = false
    },
    setData(data) {
      this.baseSource.id = data.id
      this.baseSource.stateName =
        {
          [ENTERPRISE_PLAN_STATUS.ON]: '上架',
          [ENTERPRISE_PLAN_STATUS.OFF]: '下架',
        }[String(data.state)] || '--'
      this.baseSource.gmtCreate = data.gmtCreate
      this.baseSource.name = data.name
      this.baseSource.brandName = data.brandName || '--'
      this.baseSource.seriesName = data.seriesName || '--'
      this.baseSource.modelName = data.modelName || '--'

      this.configSource.rentCategoryName =
        categoryList[data.rentCategory] || '--'

      const unit = RENT_PERIOD_TYPE_MAP[data.rentPeriodType]
      this.configSource.rentPeriodName =
        data.rentPeriod != null && unit ? `${data.rentPeriod}${unit}` : '--'
      this.configSource.presentDays =
        data.presentDays != null ? `${data.presentDays}天` : '--'

      this.feeTableData = (data.orderPlanFeeList || []).map((item) => ({
        ...item,
        name: item.typeName || '--',
        fundType: item.fundType || item.type,
        payMode: item.payMode || item.payMethod,
      }))
    },
    getPayModeText(payMode) {
      return PAY_MODE_MAP[payMode] || '--'
    },
    formatAmount(row) {
      if (row.amount != null) return row.amount
      if (row.payAmount != null) return row.payAmount
      return '--'
    },
    formatPayDay(row) {
      if (row.payPost === 10) return '自定义'
      if (row.payDay != null) {
        const prefix = row.payPost === 1 ? '下期' : '当期'
        return `${prefix}${row.payDay}日`
      }
      return '--'
    },
    goEditPage() {
      this.$router.push({
        path: '/car_to_lease/enterprisePlan/form',
        query: { mode: 'edit', id: this.id },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.orderConfig {
  margin-bottom: 10px;
}
.add-table {
  margin-bottom: 20px;
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
</style>
